/* @flow */
import React from 'react'
import ReactDOM from 'react-dom'
import Regions from './Regions'
import RegionPickerTrigger from './RegionPickerTrigger'
import { API_WIDGETDATA_URI, JOBS_REGIONS } from '../../../constants'
import Loader from '../../utils/Loader'
import request from '../../utils/Request'
import SectionsMenu from '../../utils/SectionsMenu'
import WidgetContainer from '../../containers/WidgetContainer'
import WidgetWithSections from '../WidgetWithSections'
import JobsContainer from './JobsContainer'
import SpirMonWrapper from '../Advert/SpirMonWrapper'
import { type JobsWidgetProps } from './Types'

const JOBS_SECTION_NAME = 'Práce'
const DEFAULT_REGION = JOBS_REGIONS[0]

class Jobs extends WidgetWithSections {
  constructor (props: JobsWidgetProps) {
    super(props)

    this.persistedKeys.push('activeRegion')

    this.state = Object.assign({}, this.state, {
      activeRegion: DEFAULT_REGION,
      isLoading: false,
      isRegionPickerOpen: false
    })

    this.handleRegionClick = this.handleRegionClick.bind(this)
    this.handleClickOutsideRegions = this.handleClickOutsideRegions.bind(this)
    this.handleRegionPickerTriggerClick = this.handleRegionPickerTriggerClick.bind(this)
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutsideRegions)

    const {
      activeRegion
    } = this.state

    if (activeRegion.guid !== DEFAULT_REGION.guid) {
      this.loadRegionData(activeRegion)
    }
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutsideRegions)
  }

  handleClickOutsideRegions: (event: MouseEvent) => void
  handleClickOutsideRegions (event: MouseEvent): void {
    if (this.state.isRegionPickerOpen &&
      !this.regionsRef.contains(event.target) &&
      !this.regionPickerTriggerRef.contains(event.target)) {
      this.setState({
        isRegionPickerOpen: false
      })
    }
  }

  handleSectionClick (activeSection: string): void {
    this.setState({
      activeBoxes: this.structureBoxesBySection(),
      activeSection
    })
  }

  loadRegionData (activeRegion: Object): void {
    const {
      boxes
    } = this.state
    const {
      widget: {
        name
      }
    } = this.props

    const requestConfig = {
      url: `${API_WIDGETDATA_URI}?region=${activeRegion.guid}`,
      method: 'post',
      data: {
        widgetConfig: {
          [name]: {
            name,
            boxesConfig: [
              {
                source: 'Jobs'
              }
            ]
          }
        }
      }
    }

    this.setState({
      isLoading: true,
      isRegionPickerOpen: false
    })

    request(requestConfig).then(response => {
      const mergedBoxes = Object.assign({}, boxes, { [JOBS_SECTION_NAME]: response.data[name].boxes })

      this.setState({
        activeRegion,
        boxes: mergedBoxes,
        isLoading: false
      })
    }).catch(() => {
      this.setState({
        isLoading: false
      })
    })
  }

  handleRegionClick: (activeRegion: Object) => void
  handleRegionClick (activeRegion: Object): void {
    this.loadRegionData(activeRegion)
  }

  handleRegionPickerTriggerClick: () => void
  handleRegionPickerTriggerClick (): void {
    this.setState({
      isRegionPickerOpen: !this.state.isRegionPickerOpen
    })
  }

  render () {
    const {
      activeRegion,
      activeSection,
      boxes,
      isLoading,
      isRegionPickerOpen,
      sections
    } = this.state

    const {
      activeDynamicLayout,
      widget,
      googleAnalytics,
      widget: {
        utmMedium,
        utmSource,
        meta: {
          admon
        },
        abTestCampaign
      }
    } = this.props

    const utmParams = {
      utmSource,
      utmMedium,
      utmCampaign: abTestCampaign
    }

    const activeBoxes = boxes[activeSection]

    if (!activeBoxes.length) {
      return null
    }

    const headlineContent = (activeSection === JOBS_SECTION_NAME) ? <RegionPickerTrigger
      activeRegion={activeRegion}
      isOpen={isRegionPickerOpen}
      onClick={this.handleRegionPickerTriggerClick}
      ref={ref => { this.regionPickerTriggerRef = ReactDOM.findDOMNode(ref) }}
    /> : null

    return (
      <WidgetContainer googleAnalytics={googleAnalytics} widget={widget} headlineContent={headlineContent} activeSection={sections.indexOf(activeSection)}>
        {
          isLoading &&
          <Loader/>
        }
        <SectionsMenu
          activeSection={activeSection}
          onSectionClick={this.handleSectionClick.bind(this)}
          sections={sections}
        />
        <JobsContainer
          googleAnalytics={googleAnalytics}
          boxes={activeBoxes}
          utmParams={utmParams}
          admon={admon}
        />
        <Regions regions={JOBS_REGIONS}
          activeRegion={activeRegion}
          device={activeDynamicLayout}
          isOpen={isRegionPickerOpen}
          onRegionClick={this.handleRegionClick}
          ref={ref => { this.regionsRef = ReactDOM.findDOMNode(ref) }}
        />
      </WidgetContainer>
    )
  }
}

export default SpirMonWrapper(Jobs)
